iScreenWizard.controller('C2PIdeaalscoresController', function ($scope, $state, $mdDialog, $filter, Ajax, Dictionary, ErrorHandler, userService, c2pService) {

    $scope.userService = userService;
    $scope.c2p = c2pService.model;

    $scope.competentieprofielen = [];

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        params = {
            _method: 'get_ideaalscore_data_competentieprofielen',
            intellectuele_competentie_optie: c2pService.model.intellectuele_competentie_optie,
            testafname_id: c2pService.model.testafname.id,
            competentieprofiel_ids: []
        };
        angular.forEach(c2pService.model.competentieprofielen, function(competentieprofiel) {
            params.competentieprofiel_ids.push(competentieprofiel.id);
        });
        if (c2pService.model.matching_session_id) {
            params.matching_session_id = c2pService.model.matching_session_id;
        }
        Ajax.post('matching', params).then(function(response) {
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                c2pService.model.matching_session_id = response.data.matching_session_id;
                c2pService.SaveState();
                $scope.competentieprofielen = response.data.competentieprofielen;
            }
        });
    };
    $scope.refresh = refresh;

    $scope.resetIdeaalscores = function(competentieprofiel) {
        angular.forEach(competentieprofiel.competentietypes, function(competentietype) {
            angular.forEach(competentietype.competenties, function(competentie) {
                competentie.min_ideaalscore_aangepast = competentie.min_ideaalscore_profiel;
                competentie.max_ideaalscore_aangepast = competentie.max_ideaalscore_profiel;
            });
        });
    };

    $scope.match = function() {
        c2pService.model.competentieprofielen = $scope.competentieprofielen;
        c2pService.SaveState();
        $state.go('matching/c2p/resultaten');
    };



});